import { getNumber } from "./number.helper";

// Helper to read a control value supporting both camelCase and Capitalized names
const getControlValue = (form, baseName) => {
  if (!form) return undefined;
  const control =
    form.get(baseName) ||
    form.get(baseName.charAt(0).toUpperCase() + baseName.slice(1));
  return control ? control.value : undefined;
};

// Trial period days required only when allowTrialPeriod / AllowTrialPeriod is 1
export const trialPeriodDaysValidator = (control) => {
  const form = control.parent;
  if (!form) return null;
  const allow = getControlValue(form, 'allowTrialPeriod');
  if (allow !== 1 && allow !== '1') return null;
  const value = getNumber(control.value);
  if (value === '' || value == null) return { required: true };
  if (isNaN(value) || getNumber(value) <= 0) return { isGreaterThanZero: { valid: false, actual: control.value, message: "Value should be greater than 0." } };
  if (getNumber(value) > 365) return { max: { valid: false, actual: control.value, message: "Value should be less than or equal to 365." } };
  return null;
};

// Generic helper: required when controlling field has specific value(s)
const requiredWhenControlEquals = (
  control,
  controlName,
  expectedValues,
  isGreaterThanZero = true
) => {
  const form = control.parent;
  if (!form) return null;
  const controllingValue = getControlValue(form, controlName);
  if (!expectedValues.includes(controllingValue)) return null;
  const value = getNumber(control.value);
  if (value === '' || value == null) return { required: true };
  if (isGreaterThanZero && (isNaN(value) || getNumber(value) <= 0)) return { isGreaterThanZero: { valid: false, actual: control.value, message: "Value should be greater than 0." } };
  return null;
};

export const borrowersUnlimitedValidator = (control) =>
  requiredWhenControlEquals(control, 'noofBorrowers', [1, '1']);

export const partnersUnlimitedValidator = (control) =>
  requiredWhenControlEquals(control, 'noofPartners', [1, '1']);

export const usersUnlimitedValidator = (control) =>
  requiredWhenControlEquals(control, 'noofUsers', [1, '1']);

export const transactionsUnlimitedValidator = (control) =>
  requiredWhenControlEquals(control, 'noofTransactions', [1, '1']);

export const creditReportUnlimitedValidator = (control) => {
  const form = control.parent;
  if (!form) return null;
  const creditReport = getControlValue(form, 'creditReport');
  const creditReportStatus = getControlValue(form, 'creditReportStatus');
  if (creditReport !== 1 && creditReport !== '1') return null;
  if (creditReportStatus !== 1 && creditReportStatus !== '1') return null;
  const value = getNumber(control.value);
  if (value === '' || value == null) return { required: true };
  if (isNaN(value) || getNumber(value) <= 0) return { isGreaterThanZero: { valid: false, actual: control.value, message: "Value should be greater than 0." } };
  return null;
};

export const thirdPartyReportsUnlimitedValidator = (control) => {
  const form = control.parent;
  if (!form) return null;
  const thirdPartyReports = getControlValue(form, 'thirdPartyReports');
  const thirdPartyReportsStatus = getControlValue(form, 'thirdPartyReportsStatus');
  if (thirdPartyReports !== 1 && thirdPartyReports !== '1') return null;
  if (thirdPartyReportsStatus !== 1 && thirdPartyReportsStatus !== '1') return null;
  const value = getNumber(control.value);
  if (value === '' || value == null) return { required: true };
  if (isNaN(value) || getNumber(value) <= 0) return { isGreaterThanZero: { valid: false, actual: control.value, message: "Value should be greater than 0." } };
  return null;
};

export const helloSignUnlimitedValidator = (control) => {
  const form = control.parent;
  if (!form) return null;
  const helloSign = getControlValue(form, 'helloSign');
  const helloSignStatus = getControlValue(form, 'helloSignStatus');
  if (helloSign !== 1 && helloSign !== '1') return null;
  if (helloSignStatus !== 1 && helloSignStatus !== '1') return null;
  const value = getNumber(control.value);
  if (value === '' || value == null) return { required: true };
  if (isNaN(value) || getNumber(value) <= 0) return { isGreaterThanZero: { valid: false, actual: control.value, message: "Value should be greater than 0." } };
  return null;
};

export const creditReportStatusValidator = (control) =>
  requiredWhenControlEquals(control, 'creditReportStatus', [1, '1'], false);

export const thirdPartyReportsStatusValidator = (control) =>
  requiredWhenControlEquals(control, 'thirdPartyReportsStatus', [1, '1'], false);

export const helloSignStatusValidator = (control) =>
  requiredWhenControlEquals(control, 'helloSignStatus', [1, '1'], false);

